import { render, staticRenderFns } from "./ReviewSurvey.vue?vue&type=template&id=03b5f7d3&scoped=true&"
import script from "./ReviewSurvey.vue?vue&type=script&lang=ts&"
export * from "./ReviewSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewSurvey.vue?vue&type=style&index=0&id=03b5f7d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5f7d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b5f7d3')) {
      api.createRecord('03b5f7d3', component.options)
    } else {
      api.reload('03b5f7d3', component.options)
    }
    module.hot.accept("./ReviewSurvey.vue?vue&type=template&id=03b5f7d3&scoped=true&", function () {
      api.rerender('03b5f7d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Survey/ReviewSurvey.vue"
export default component.exports